import React, { useState, useEffect } from "react";
import { Row, Col, Alert, Container, CardBody, Card } from "reactstrap";
import {Link, Redirect } from "react-router-dom";

import { AvForm, AvField } from "availity-reactstrap-validation";
import CMSLogo from "../../assets/images/long-logo.svg";
import { CircularProgress } from "@material-ui/core";
import SweetAlert from "react-bootstrap-sweetalert";
import { useAuth } from "../../Context/Auth";
import { useTranslation } from 'react-i18next';
import { FaHome } from "react-icons/fa";


const OtpLogin = (props) => {
  const [otp, setOTP] = useState("");
  const [userID, setUserID] = useState();
  const [otpError, setOTPError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [initialTime] = useState(900);
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [startTime, setStartTime] = useState(Date.now());
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { setAuthTokens } = useAuth();

  useEffect(() => {
    setUserID(props.location?.state?.userId);
    const token = localStorage.getItem("AuthenticationToken");
    if (token) {
        setLoggedIn(true);
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { t } = useTranslation();


  
  const calculateTimeLeft = () => {
    const elapsedTime = Math.floor((Date.now() - startTime) / 1000);
    const timeRemaining = Math.max(initialTime - elapsedTime, 0);
    setTimeLeft(timeRemaining);
  };
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      calculateTimeLeft();
    }, 1000);
  
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !timeLeft) {
        setStartTime(Date.now());
      }
    };
  
    document.addEventListener('visibilitychange', handleVisibilityChange);
  
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [timeLeft]);
  
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  
  // handleSubmit
  const handleSubmit = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    var urlencoded = new URLSearchParams();
    urlencoded.append("user_id", userID);
    urlencoded.append("otp", otp);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    let otpLoginResponse = await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/otplogin`,
      requestOptions
    ).then((response) => {
      return response.text();
    });
    let responseMessage = JSON.parse(otpLoginResponse);
    if (responseMessage?.token) {
      setLoader(false);
      setAuthTokens(responseMessage?.token);
      localStorage.setItem("userRole", responseMessage?.role);
      localStorage.setItem(
        "userPermissions",
        JSON.stringify(responseMessage?.user_permissions)
      );
    //   localStorage.setItem("userEmail", userName);
      setLoggedIn(true);
    } else {
      if (responseMessage?.errors) {
        setOTPError(responseMessage?.errors[0]);
      } else if (!responseMessage?.success) {
        setOTPError('The OTP is incorrect or expired');
      }
      setLoader(false);
    }
  };

//   if (localStorage.getItem("isMerchant") == "true") {
//     return <Redirect to="/merchant-dashboard" />;
//   }
  if (isLoggedIn) {
    let role = localStorage.getItem("userRole");
    if (role) {
      if (role.toLowerCase().includes("merchant")) {
        return <Redirect to="/merchant-dashboard" />;
      } else if (role.toLowerCase().includes("promo")){
        return <Redirect to="/select-merchant" />;
      } else {
        return <Redirect to="/carousel-banners/frx-home" />;
      }
    }
  }

  const regenerateOTP=()=>{
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");   
    var urlencoded = new URLSearchParams();
    urlencoded.append("user_id", userID);
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };
    
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/regenerateotp`, requestOptions)
      .then(response => {
        if (response.status === 200) {
            setSuccesAlert(true);
          } else {
            setErrorMessage(t('Unable to Add'));
            setErrorAlert(true);
          }
      })
      .catch(error => console.log('error', error));

  }
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          setSuccesAlert(false);
          setOTPError("")
        }}
        onConfirm={() => {
          setSuccesAlert(false);
          window.location.reload()
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {t('Check Email For OTP Code')}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setOTPError("")
        }}
      >
        {errorMessage ? errorMessage : t('Unable_to_Add_Popup_Error_Msg')}
      </SweetAlert>
    );
  };


  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <FaHome size={32} />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center"></div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody style={{ position: "relative" }} className="p-5">
                  <div
                    style={{
                      position: "absolute",
                      color: "#46464669",
                      bottom: 10,
                      right: 10,
                    }}
                    className="text-center"
                  >
                    <strong>{`${t('Expires After')}:`}</strong>
                    {` ${formattedTime}`}
                  </div>
                  <Link to="/" className="mb-2 d-block auth-logo">
                    <img
                      style={{ marginLeft: "auto", marginRight: "auto" }}
                      src={CMSLogo}
                      alt=""
                      height="40"
                      className="logo logo-dark"
                    />
                  </Link>
                  <div className="text-center mt-3">
                    <h5
                      style={{
                        color: "#000000 !important",
                        fontSize: 15,
                        margin: 0,
                      }}
                    >
                      {t('OTP LOGIN')}
                    </h5>
                    <p
                      style={{ color: "#000000 !important" }}
                      className="text-muted"
                    >
                     {t('Please Check Email And Enter OTP')}
                    </p>
                  </div>
                  <div className="p-2 mt-4">
                    <AvForm className="form-horizontal">
                      {props.error && typeof props.error === "string" ? (
                        <Alert color="danger">{props.error}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <AvField
                          name="otp"
                          label="One Time Password"
                          type="number"
                          className="form-control"
                          placeholder="Enter Code"
                          onChange={(e) => {
                            setOTP(e.target.value);
                          }}
                        />
                        {otpError ? (
                          <div
                            style={{
                              fontSize: 12,
                              color: "red",
                              fontWeight: 400,
                            }}
                          >
                            {otpError}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="mt-3">
                        <button
                        //   style={{ background: "#000000", border: "#000000" }}
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          onClick={() => {
                            handleSubmit();
                            setLoader(true);
                          }}
                          disabled={loader}
                        >
                          {loader ? (
                            <CircularProgress
                              size={15}
                              value={100}
                              color={"white"}
                            />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                      <div
                        style={{
                          justifyContent: "space-around",
                          display: "flex",
                        }}
                      >
                        <div className="mt-3 ">
                          <Link
                            to="/"
                            className="text-dark  text-decoration-underline"
                          >
                            {t('Back To Login')}
                          </Link>
                        </div>

                        <div className="mt-3  text-decoration-underline">
                          <div style={{cursor:"pointer"}}
                           className="text-dark"
                           onClick={()=>{regenerateOTP()}}
                           >
                           Regenerate OTP
                          </div>
                        </div>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
            {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OtpLogin;
